import { NgModule } from '@angular/core';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { Dialog, DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { Fluid } from 'primeng/fluid';
import { IconFieldModule } from "primeng/iconfield";
import { InputGroup, InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from "primeng/inputicon";
import { InputMask } from 'primeng/inputmask';
import { InputNumber } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { SelectButton, SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonModule } from "primeng/splitbutton";
import { SplitterModule } from 'primeng/splitter';
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { Tooltip } from 'primeng/tooltip';

@NgModule({
  imports: [FileUploadModule,ChipModule,SkeletonModule,BreadcrumbModule,InputNumber,SelectButton,Dialog,ListboxModule,ButtonModule,ConfirmDialog,InputMask,Fluid,Tooltip,MultiSelectModule,SplitterModule,InputGroup,InputGroupAddonModule,AutoCompleteModule],
  declarations: [],
  providers: [],
  exports: [
    ChipModule,
    FieldsetModule,
    SkeletonModule,
    BreadcrumbModule,
    Tooltip,
    ConfirmDialog,
    CheckboxModule,
    ListboxModule,
    TableModule,
    ToolbarModule,
    CardModule,
    DialogModule,
    SplitterModule,
    FloatLabelModule,
    AutoCompleteModule,
    ButtonModule,
    MultiSelectModule,
    SelectModule,
    TabsModule,
    InputGroup,
    InputTextModule,
    DatePickerModule,
    RadioButtonModule,
    TextareaModule,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    SelectButtonModule,
    TagModule,
    ToastModule,
    AccordionModule,
    AvatarModule,
    ToolbarModule,
    InputMask,
    InputNumber,
    IconFieldModule,
    InputIconModule,
    SplitButtonModule,
    StepperModule,
    FileUploadModule
  ]
})
export class PrimengModule {
}
